/** Optional at-rest field cipher — H2 / SPEC §16 */

export type AtRestCipher = {
  seal: (plaintext: string) => Promise<string>;
  open: (ciphertext: string) => Promise<string>;
};

let cipher: AtRestCipher | null = null;

export function setAtRestCipher(next: AtRestCipher | null): void {
  cipher = next;
}

export function getAtRestCipher(): AtRestCipher | null {
  return cipher;
}

export const ENC_PREFIX = "enc:v1:";

export function isSealedField(value: string): boolean {
  return value.startsWith(ENC_PREFIX);
}

export async function sealField(value: string): Promise<string> {
  if (!cipher || !value || isSealedField(value)) return value;
  return ENC_PREFIX + (await cipher.seal(value));
}

export async function openField(value: string): Promise<string> {
  if (!cipher || !isSealedField(value)) return value;
  try {
    return await cipher.open(value.slice(ENC_PREFIX.length));
  } catch {
    return "[unable to decrypt local field]";
  }
}
